// Resource data for Grounded Wellness with Jill
// 4 Sections: Recipes, Movement, Wellness, Whole Self

export const resourceSections = [
  {
    id: 'recipes',
    title: 'Recipes',
    subtitle: 'Nourish Your Body',
    description: 'Simple, grounded recipes aligned with detox eating, anti-inflammatory principles, and SCD diet.',
    image: 'https://images.unsplash.com/photo-1466637574441-749b8f19452f?w=800',
    color: 'from-white/40 to-stone-200/60',
    titleColor: 'text-emerald-200',
  },
  {
    id: 'movement',
    title: 'Movement',
    subtitle: 'Restore Function',
    description: 'Resources for reconnecting with your body through functional movement, breath, and fascial work.',
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=800',
    color: 'from-stone-600/80 to-stone-700/90',
    titleColor: 'text-emerald-200',
  },
  {
    id: 'wellness',
    title: 'Wellness',
    subtitle: 'Optimize Health',
    description: 'Guides for sleep, stress, digestion, and holistic approaches to restoring vitality.',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800',
    color: 'from-terracotta/80 to-terracotta-dark/90',
    titleColor: 'text-emerald-200',
  },
  {
    id: 'whole-self',
    title: 'Whole Self',
    subtitle: 'Deep Connection',
    description: 'Tools for the inner journey—meditation, emotional work, and connecting mind, body, and spirit.',
    image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=800',
    color: 'from-stone-500/80 to-forest/90',
    titleColor: 'text-emerald-200',
  },
];

export const movementResources = [
  // === FOUNDATIONAL ARTICLE ===
  {
    id: 'holistic-training-nutshell',
    title: 'Holistic/Restorative Personal Training in a Nutshell',
    description: 'Why our sessions are only the beginning. An invitation to understand your body as a full system — physical, mental, emotional, and energetic — and where the real work of healing actually happens.',
    image: 'https://customer-assets.emergentagent.com/job_06c44a8a-5d97-48ba-9afb-b8fb64162499/artifacts/ppnujetj_AHHW%20Kbell3.png',
    type: 'Article',
    topics: ['Philosophy', 'Corrective Exercise', 'Lifestyle', 'Integration'],
  },
  // === AVAILABLE RESOURCES (PDF Guides) ===
  {
    id: 'tending-to-injury',
    title: 'Tending to Your Injury',
    description: 'A holistic guide to healing using the PEACE & LOVE approach. Beyond RICE to true recovery.',
    image: 'https://customer-assets.emergentagent.com/job_greeting-hub-217/artifacts/6nh8i791_Helping-injured-dog-1024x683.jpg',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_0a9ff351-8b5c-42db-9af2-82d74676456a/artifacts/g6z3su63_Tending%20to%20your%20injury.pdf',
    topics: ['Injury Recovery', 'PEACE & LOVE Protocol', 'Mind-Body Connection', 'Self-Care'],
  },
  {
    id: 'body-is-a-pump',
    title: 'Did You Know Your Body Is a Pump?',
    description: 'Understanding the pump systems of your body—hydraulic, mechanical, electrical, and emotional—and how movement restores their function.',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/si94iuao_eb87f745-a947-4a79-8a2d-ec9ce943a614.png',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/4e3tcya5_Did%20You%20Know%20Your%20Body%20Is%20a%20Pump%20%282%29.pdf',
    topics: ['Body Systems', 'Fascia', 'Breath Work', 'Energy Flow'],
  },
  {
    id: 'bodies-like-water',
    title: 'What if We Treated Our Bodies Like the Ocean?',
    description: 'Restoring our relationship with our bodies through the wisdom of water. Learning to accept, flow, and work with our bodies rather than against them.',
    image: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=600',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-app-881/artifacts/inei5ija_What%20if%20we%20Treated%20our%20Bodies%20Like%20Water.pdf',
    topics: ['Body Wisdom', 'Acceptance', 'Healing', 'Mind-Body Connection'],
  },
  {
    id: 'etheric-body',
    title: 'The Etheric Body',
    description: 'Understanding the subtle energy body - the luminous blueprint that shapes, nourishes, and repairs our physical form. Includes the aura layers, chakras, and practices to strengthen your etheric field.',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-app-881/artifacts/joq4qzjn_What%20is%20The%20Etheric%20Body%20%28Aura%29.pdf',
    topics: ['Etheric Body', 'Aura', 'Energy Field', 'Subtle Body'],
  },
  {
    id: 'intro-to-metaphysics',
    title: 'Introduction To Metaphysics',
    description: 'When the body speaks through sensation, tension, or illness — the most powerful thing we can do is listen. A guide to understanding what the body is really telling us.',
    image: 'https://customer-assets-v7afamib.emergentagent.net/job_9cc27ad2-9473-4d8d-951e-838ca155566b/artifacts/xwq5781e_original-9349871-1.jpg',
    type: 'Article',
    topics: ['Metaphysics', 'Body Signals', 'Subconscious', 'Mind-Body Connection'],
  },
  // === COMING SOON ===
  {
    id: 'back-reset',
    title: 'The Back Reset',
    description: 'A comprehensive program for restoring back health and function through fascial work.',
    image: 'https://customer-assets.emergentagent.com/job_greeting-hub-217/artifacts/rzz31rvw_R%20%282%29.jpg',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Back Health', 'Posture', 'Pain Relief'],
  },
  {
    id: 'the-love-philosophy',
    title: 'The Love Philosophy',
    description: 'Developing a loving relationship with your body through mindful movement and self-compassion.',
    image: 'https://images.unsplash.com/photo-1518199266791-5375a83190b7?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Self-Love', 'Mind-Body', 'Compassion'],
  },
  {
    id: 'our-energetics',
    title: 'Our Energetics',
    description: 'Understanding the energetic body and how it influences physical movement and health.',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Energy', 'Vitality', 'Body Systems'],
  },
  {
    id: 'multi-system-beings',
    title: 'Multi System Beings',
    description: 'How our multiple body systems work together as an integrated whole.',
    image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Body Systems', 'Integration', 'Holistic Health'],
  },
  {
    id: 'our-inner-workings',
    title: 'Our Inner Workings',
    description: 'Exploring the internal processes that support movement and healing.',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/jxyzbl75_5f1ccd494938c6ffba779298688f0e59.jpg',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Internal Systems', 'Physiology', 'Body Awareness'],
  },
  {
    id: 'isolation-integration-improvisation',
    title: 'Isolation, Integration, Improvisation',
    description: 'The three stages of movement mastery and body awareness.',
    image: 'https://customer-assets.emergentagent.com/job_greeting-hub-217/artifacts/ddc2bwdi_1469208016487.webp',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Movement Mastery', 'Body Awareness', 'Flow'],
  },
  {
    id: 'brain-body-connection',
    title: 'Brain Body Connection',
    description: 'How the nervous system communicates with the body and affects movement.',
    image: 'https://images.unsplash.com/photo-1559757175-5700dde675bc?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Neurology', 'Movement Patterns', 'Mind-Body'],
  },
  {
    id: 'lengthen-to-win',
    title: 'Lengthen To Win',
    description: 'The importance of lengthening and stretching in functional movement.',
    image: 'https://images.unsplash.com/photo-1552196563-55cd4e45efb3?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Stretching', 'Flexibility', 'Recovery'],
  },
  {
    id: 'energy-centres',
    title: 'Our Energy Centres and How They Affect the Body',
    description: 'How energy centres (chakras) affect the body and movement.',
    image: 'https://images.unsplash.com/photo-1545389336-cf090694435e?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Energy', 'Chakras', 'Body Systems'],
  },
  {
    id: 'path-to-recovery',
    title: 'The Path to Recovery',
    description: 'Understanding the non-linear journey of healing and recovery.',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Recovery', 'Healing Journey', 'Patience'],
  },
  {
    id: 'how-where-to-start',
    title: 'How/Where to Start',
    description: 'Guidance for beginning your movement journey at any level.',
    image: 'https://customer-assets.emergentagent.com/job_greeting-hub-217/artifacts/bljkjtc9_tortoise%20hare.jpg',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Getting Started', 'Beginners', 'First Steps'],
  },
  {
    id: 'no-knots',
    title: "You Don't Have to Tie Yourself In Knots",
    description: 'Simple, accessible movement practices without complicated poses or positions.',
    image: 'https://images.unsplash.com/photo-1544367567-0f2fcb009e0b?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Accessibility', 'Simple Movement', 'Self-Care'],
  },
  {
    id: 'longevity',
    title: 'Longevity',
    description: 'Movement practices for long-term health and vitality.',
    image: 'https://images.unsplash.com/photo-1571019613454-1cb2f99b2d8b?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Longevity', 'Aging Well', 'Vitality'],
  },
  {
    id: 'recovery',
    title: 'Recovery',
    description: 'Essential practices and mindset for optimal recovery from movement and life.',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Recovery', 'Rest', 'Restoration'],
  },
  {
    id: 'waiting-place',
    title: 'The Waiting Place',
    description: 'Navigating the in-between times of healing and transformation.',
    image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Patience', 'Transition', 'Healing'],
  },
  {
    id: '16-remedies',
    title: '16 Remedies to Restore Our Center',
    description: 'Practical remedies and practices for returning to balance and centeredness.',
    image: 'https://images.unsplash.com/photo-1518837695005-2083093ee35b?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Centering', 'Balance', 'Restoration', 'Remedies'],
  },
];

export const wellnessResources = [
  {
    id: 'i-gotta-get-my-shift-together',
    title: 'I Gotta Get My Shift Together',
    description: "Growth isn't just effort — it's identity disruption. A workshop-style exploration of the patterns and core needs quietly steering your life, with practices for intention, energy alignment, and choosing real forward momentum.",
    image: 'https://images.unsplash.com/photo-1701634441311-e624c7fdfedf?w=600',
    type: 'Article',
    topics: ['Mindset', 'Core Needs', 'Patterns', 'Intention', 'Personal Growth', 'Nervous System'],
  },
  {
    id: 'escaping-the-dopamine-cycle',
    title: 'Escaping the Dopamine Cycle: Why Intention Matters More Than Motivation',
    description: "Dopamine isn't the pleasure chemical — it's the pursuit chemical. A clear look at the anticipation-reward loop, why modern life is a dopamine buffet, and how intention (not motivation or willpower) helps you regain choice. Includes practical ways to interrupt the cycle.",
    image: 'https://images.pexels.com/photos/16345434/pexels-photo-16345434.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=600&w=600',
    type: 'Article',
    topics: ['Dopamine', 'Intention', 'Nervous System', 'Habits', 'Focus', 'Fulfillment'],
  },
  {
    id: 'systemic-fungal-infections',
    title: 'Systemic Fungal Infections: A Holistic Guide',
    description: "When yeast or fungi move beyond localized areas and affect the body more broadly. A whole-person look at the signs (Western and Chinese Medicine), root causes, and an integrative path — conventional care, nutrition, botanicals, terrain support, and TCM.",
    image: 'https://images.unsplash.com/photo-1780253481026-951abd1c164f?w=600',
    type: 'Article',
    topics: ['Candida', 'Gut Health', 'Damp-Heat', 'Chinese Medicine', 'Terrain', 'Immunity'],
  },
  {
    id: '9-pillars-wellness',
    title: 'The 9 Pillars for Creating a Path to Wellness',
    description: 'A framework for holistic well-being covering breathing, nourishment, thoughts, hydration, movement, sleep, emotions, and whole-self integration. Not rules, but reference points for where your system needs support.',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/c38gnnan_What-are-the-8-pillars-of-wellness-1024x585.webp',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/9j8za1l7_9%20Pillars%20Of%20%20Creating%20a%20Path%20to%20Wellness%20%281%29.pdf',
    topics: ['Wellness Framework', 'Holistic Health', 'Self-Care', 'Life Balance'],
  },
  {
    id: 'all-healing-self-healing',
    title: 'All Healing Is Self Healing',
    description: 'Understanding the journey from constriction to expansion. A guide to self-compassion, mindfulness, and creating a safe inner environment for healing.',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/h5ik7oh5_dreamstime_m_70481329-204275082.jpg',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-app-881/artifacts/n4ayn2x6_All%20Healing%20Is%20Self%20Healing%20%283%29.pdf',
    topics: ['Self-Healing', 'Mindfulness', 'Self-Compassion', 'Inner Work'],
  },
  {
    id: 'thumb-rules-wellbeing',
    title: 'Great Thumb Rules Towards WellBeing',
    description: 'Small changes, big impact. Practical food guidance for healthier choices—nutrient-dense foods, quality meats, healthy fats, and the Love Philosophy approach to eating.',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/ht619e1k_rule-of-thumb-business-valuation.jpg',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_0a9ff351-8b5c-42db-9af2-82d74676456a/artifacts/bcta9000_Great%20Thumb%20Rules%20Towards%20Wellbeing%20%281%29.pdf',
    topics: ['Nutrition', 'Food Quality', 'Healthy Eating', 'Love Philosophy'],
  },
  {
    id: 'try-not-to-lose-the-plot',
    title: '"Try Not to Lose the Plot!"',
    description: 'An unorthodox but compassionate approach to maintaining your health during crisis. Learn about survival mode, self-compassion, and practical add-ins that actually help.',
    image: 'https://customer-assets.emergentagent.com/job_hello-app-881/artifacts/hxxmppmp_writing-tips-3-dont-lose-the-plot.jpg',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_0a9ff351-8b5c-42db-9af2-82d74676456a/artifacts/6hdepw4w_The%20%27Try%20Not%20to%20Loose%20the%20Plot%21%27%20Approach%20to%20Your%20Health%20in%20Difficult%20Times%20%281%29.pdf',
    topics: ['Resilience', 'Self-Compassion', 'Crisis Support', 'Difficult Times'],
  },
  {
    id: '8-weeks-better-sleep',
    title: '8 Weeks to A Better Sleep',
    description: 'A comprehensive guide to restoring your sleep. Covers cortisol science, 3 hormonal pathways, sleep hygiene tips, supplements, stress reduction, and an 8-week bedtime adjustment plan.',
    image: 'https://images.unsplash.com/photo-1541781774459-bb2af2f05b55?w=600',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-world-4550/artifacts/kj60v01o_8%20weeks%20to%20a%20better%20sleep.pdf',
    topics: ['Sleep', 'Rest', 'Cortisol', 'Circadian Rhythm', 'Stress'],
  },
  {
    id: 'attainable-approach-stress',
    title: 'An Attainable Approach to Reducing Stress',
    description: 'A realistic framework for managing stress: Eliminate, Uncover, Manage. Includes self-care essentials, working with emotions, and understanding your inner voice.',
    image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=600',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-world-4550/artifacts/tzeyfdri_An%20Attainable%20Approach%20to%20Reducing%20Stress%20in%20our%20Lives.pdf',
    topics: ['Stress', 'Self-Compassion', 'Emotions', 'Self-Care'],
  },
  {
    id: 'why-we-suck-at-recognizing-stress',
    title: 'Why We Suck at Recognizing Stress',
    description: 'Understanding our built-in blind spots. Explores 8 reasons stress flies under the radar and 7 gentle remedies to rebuild awareness. Includes the cortisol connection and nervous system science.',
    image: 'https://customer-assets.emergentagent.com/job_hello-app-881/artifacts/robu4fh7_image.png',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_0a9ff351-8b5c-42db-9af2-82d74676456a/artifacts/a9f2f0ns_Why%20as%20humans%2C%20we%20notoriously%20suck%20at%20recognizing%20stress%20%282%29.pdf',
    topics: ['Stress', 'Awareness', 'Nervous System', 'Self-Care'],
  },
  {
    id: 'living-with-illness',
    title: 'Living with Illness & Dis-ease',
    description: 'A comprehensive guide for navigating challenging times with illness or disease. Includes the 6 Foundations, stages of healing, practical tools, and mind-body approaches.',
    image: 'https://customer-assets.emergentagent.com/job_hello-app-881/artifacts/p7hpolej_woman-walking-through-forest-with-backpack_153912-282767.avif',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_0a9ff351-8b5c-42db-9af2-82d74676456a/artifacts/q3yxheso_Living%20With%20Illness%20and%20Dis-ease%20%282%29.pdf',
    topics: ['Chronic Illness', 'Healing Journey', 'Mind-Body', 'Self-Care'],
  },
  {
    id: 'adrenal-support',
    title: 'Adrenal Support',
    description: 'Understanding and restoring balance to your stress response. An 8-step guide covering sleep, nutrition, supplements, and ME rituals for adrenal fatigue recovery.',
    image: 'https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=600',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_0a9ff351-8b5c-42db-9af2-82d74676456a/artifacts/wbkpeh46_Adrenal%20Support.pdf',
    topics: ['Adrenals', 'Fatigue', 'Energy', 'Cortisol', 'Sleep'],
  },
  {
    id: 'path-to-wellness',
    title: 'Path to Wellness',
    description: 'Coming soon — A guided journey through the foundations of holistic health.',
    image: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Holistic Health', 'Wellness Journey'],
  },
];

export const wholeSelfResources = [
  {
    id: 'life-journey-out-of-crisis',
    title: 'A Life Journey: Out of Crisis',
    description: 'A map for the journey out of crisis — from survival to becoming — in three levels: Foundation, Preparation and Transformation. Includes the Seven Hermetic Principles for contemplation.',
    image: 'https://customer-assets-v7afamib.emergentagent.net/job_9cc27ad2-9473-4d8d-951e-838ca155566b/artifacts/44mzytzg_ChatGPT%20Image%20Sep%201%2C%202026%2C%2010_13_17%20AM.png',
    type: 'Article',
    topics: ['Crisis to Calm', 'Nervous System', 'Neutrality', 'Release', 'Hermetic Principles'],
  },
  {
    id: 'compassion-fatigue',
    title: 'Compassion Fatigue',
    description: '"Where did I go?" — When you stop feeling like yourself, there\'s a point where it\'s not just tired anymore. Understanding depletion at the nervous system level and the path back to reconnection.',
    image: 'https://images.unsplash.com/photo-1616081440193-f49d7c56969f?w=600',
    type: 'Article',
    topics: ['Nervous System', 'Self-Care', 'Burnout', 'Emotional Health', 'Reconnection'],
  },
  {
    id: 'our-relationship-with-anxiety',
    title: 'Our Relationship with Anxiety',
    description: "It's not in your head — it's in your body. Anxiety as a real physiological experience and a messenger from the nervous system. How inquiry, downshifting, and capacity-building change our relationship with it.",
    image: 'https://images.pexels.com/photos/4098224/pexels-photo-4098224.jpeg?w=600',
    type: 'Article',
    topics: ['Nervous System', 'Anxiety', 'Stress', 'Breathwork', 'Self-Regulation'],
  },
  {
    id: 'why-anxiety-creates-symptoms',
    title: 'Why Anxiety Creates Symptoms in the Body',
    description: "Anxiety isn't 'just a thought' — it's a biochemical event. A clear look at the brain-body stress cascade (amygdala, HPA axis, adrenaline, cortisol) and why the heart, lungs, gut, and muscles all respond. Includes a medical-safety caveat.",
    image: 'https://images.pexels.com/photos/3812752/pexels-photo-3812752.jpeg?w=600',
    type: 'Article',
    topics: ['Nervous System', 'Stress Response', 'HPA Axis', 'Anxiety', 'Body Awareness'],
  },
  {
    id: 'living-beyond-self-sabotage',
    title: 'Living Beyond Self-Sabotage',
    description: 'Knowing our inner parts to live in harmony. Explores the psyche, conscious/subconscious mind, ego, shadow, inner critic, nervous system patterns, the "I know better but don\'t do it" loop, the mother wound, and archetypes for self-leadership.',
    image: 'https://images.unsplash.com/photo-1499209974431-9dddcece7f88?w=600',
    type: 'Presentation',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-world-4550/artifacts/okp3jtft_Self_Sabotage_Inner_Parts_Workshopnewest.pptx',
    topics: ['Self-Sabotage', 'Inner Parts', 'Shadow Work', 'Nervous System', 'Self-Leadership'],
  },
  {
    id: 'all-healing-is-self-healing',
    title: 'How Do We Move from Constriction to Expansion?',
    description: 'Understanding the inner work of healing through self-compassion, mindfulness, and creating a safe inner environment.',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/d1yly8sf_Subheading%20%281%29.png',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-app-881/artifacts/7juvouxb_All%20Healing%20Is%20Self%20Healing.pdf',
    topics: ['Self-Healing', 'Mindfulness', 'Self-Compassion', 'Inner Work'],
  },
  {
    id: 'mind-house',
    title: 'Mind House: Meditation 101',
    description: 'A comprehensive meditation guide with 6 Levels of Awareness, Quantum Psychology principles, MBSR techniques, and the 7 Homecomings. Learn formal and informal meditation practices.',
    image: 'https://images.unsplash.com/photo-1508672019048-805c876b67e2?w=600',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_0a9ff351-8b5c-42db-9af2-82d74676456a/artifacts/m3u87c8a_Mind%20House%20Final.pdf',
    topics: ['Meditation', 'Mindfulness', 'Awareness', 'Quantum Psychology'],
  },
  {
    id: 'creating-harmony',
    title: 'Creating Harmony',
    description: 'A life assessment tool using the Circle of Personal Perspective and Roving Priorities. Explore 8 areas of life, answer deep coaching questions, and align your energy with your true priorities.',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/krf4ufj8_cairn-sm.jpg',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-world-4550/artifacts/6c1wsd1j_Copy%20of%20Copy%20of%20Copy%20of%20Copy%20of%20White%20with%20Light%20Green%20Leaf%20Logo%20Official%20Letterhead%20%281%29.pdf',
    topics: ['Life Balance', 'Self-Assessment', 'Priorities', 'Coaching'],
  },
  {
    id: 'empath-survival-guide',
    title: 'The Empath Survival Guide',
    description: 'Essential guidance for sensitive souls navigating an overwhelming world.',
    image: 'https://images.unsplash.com/photo-1516302752625-fcc3c50ae61f?w=600',
    type: 'Presentation',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_restore-website/artifacts/4mp6d6e4_The%20Empath%20Survival%20Guide.pptx',
    topics: ['Empaths', 'Sensitivity', 'Boundaries'],
  },
  {
    id: 'empath-enhancement-guide',
    title: 'The Empath Enhancement Guide',
    description: 'A deep dive into being an empath through earthly and sacred lenses. Covers psychological roots, nervous system sensitivity, chakra connections (solar plexus & clairsentience), and spiritual perspectives. Includes grounding techniques, energy shielding, crystal & salt bath practices, boundary setting exercises, and an Empath\'s Toolkit creation guide.',
    image: 'https://customer-assets.emergentagent.com/job_hello-starter-17/artifacts/97kqqido_6.png',
    type: 'PDF Guide',
    downloadUrl: 'https://customer-assets.emergentagent.com/job_hello-world-4084/artifacts/snyxdp3c_The%20Empath%20Enhancement%20Guide.pdf',
    topics: ['Empaths', 'Energy Protection', 'Boundaries', 'Grounding', 'Chakras', 'Self-Care'],
  },
  {
    id: 'forward-momentum',
    title: 'Forward Momentum',
    description: 'What\'s driving you, whether you know it or not. Exploring the six core needs, our lead systems, and why we move the way we do — inspired by Tony Robbins\' framework, digested through personal experience.',
    image: 'https://customer-assets-v7afamib.emergentagent.net/job_9cc27ad2-9473-4d8d-951e-838ca155566b/artifacts/inciqrkk_theroadahead-160115123008-thumbnail-4.webp',
    type: 'Article',
    topics: ['Core Needs', 'Self-Awareness', 'Momentum', 'Identity', 'Growth'],
  },
  {
    id: 'intro-to-metaphysics',
    title: 'Introduction To Metaphysics',
    description: 'Our bodies are not only physical — they are plasma-and-particle vessels alive with energy. A guide to understanding body signals and what they may reflect.',
    image: 'https://customer-assets-v7afamib.emergentagent.net/job_9cc27ad2-9473-4d8d-951e-838ca155566b/artifacts/xwq5781e_original-9349871-1.jpg',
    type: 'Article',
    topics: ['Metaphysics', 'Body Signals', 'Subconscious', 'Mind-Body Connection'],
  },
  {
    id: 'emotional-eating',
    title: 'Emotional Eating',
    description: 'Coming soon — Understanding and healing our relationship with food and emotions.',
    image: 'https://images.unsplash.com/photo-1493770348161-369560ae357d?w=600',
    type: 'Coming Soon',
    downloadUrl: null,
    topics: ['Emotional Health', 'Food Relationship', 'Healing'],
  },
];
